<template>
  <v-overlay :opacity=".80" :value="show" :absolute="false">
      <v-progress-circular v-if="!progressBar" indeterminate :size="progressSize">
        {{message}}
      </v-progress-circular>
      <p v-if="progressBar">{{message}}</p>
      <v-progress-linear v-if="progressBar" color="primary" indeterminate></v-progress-linear>
    </v-overlay>
</template>

<script>

export default {
  name: 'BaseMitLoading',
  components: {},
  props: {
    show:{
      default: false,
      type: Boolean
    },
    message: {
      default: 'Loading...',
      type: String
    },
    progressBar:{
      default: false,
      type: Boolean
    },
    progressSize:{
      default: 88,
      type: Number
    }
  },
  data: function() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
</style>
